import React, { useContext, useMemo } from "react";
import "../global/pages.css";
import "./Success.css";
import { Link } from "react-router-dom";
import { server } from "../configs";
import { Context } from "../GlobalContext";
import axios from "axios";
import Swal from "sweetalert2";

const Success = ({ history }) => {
  const { surveyList, userData, setUserData, token } = useContext(Context);

  const prevSurveyType = useMemo(
    () =>
      surveyList[surveyList.length - 1].surveyType === "아동척도"
        ? "a"
        : surveyList[surveyList.length - 1].surveyType === "영향평가"
        ? "b"
        : "c",
    [surveyList]
  );

  const prevSurveyNumber = useMemo(() => surveyList.length - 1, [surveyList]);

  const prevTopicNumber = useMemo(
    () => surveyList[prevSurveyNumber].topics.length - 1,
    [surveyList, prevSurveyNumber]
  );

  const prevScreenNumber = useMemo(
    () =>
      surveyList[prevSurveyNumber].topics[prevTopicNumber].screens.length - 1,
    [surveyList, prevTopicNumber, prevSurveyNumber]
  );

  const submitGift = (option) => {
    const jwt = localStorage.getItem("jwt");
    const content = {
      giftOption: option,
      giftContact: "",
      gift: "",
    };

    axios
      .patch(server + "/user/users/me", content, {
        headers: { authorization: jwt },
      })
      .then(({ status }) => {
        // console.log(status);
        setUserData({
          ...userData,
          ...content,
        });
        localStorage.removeItem("done");
        history.push("/token/" + token + "/finished");
      })
      .catch((e) => {
        console.log(e);
        history.push("/noToken");
      });
  };

  return (
    <div className="container" id="success__container">
      <div className="logo" id="success__logo">
        <img src={userData.gov.logoUrl} alt="state logo" />
      </div>
      <div className="title" id="success__title">
        <h4>MISSION COMPLETE!</h4>
        <h3>
          조사가 완료되었습니다.
          <br />
          조사에 응해주셔서 <br className="pc-hide" />
          대단히 감사합니다.
        </h3>
      </div>
      <div className="next-button">
        <Link
          to={{ pathname: "/token/" + token + "/done", state: "신청" }}
          className="btn"
          alt="답례품 신청 버튼"
        >
          답례품 신청하기
        </Link>
        <Link
          to={{ pathname: "/token/" + token + "/done", state: "기부" }}
          id="second-btn"
          className="btn"
          alt="나의 답례품 기부하기 버튼"
        >
          나의 답례품 기부하기
        </Link>
        <Link
          to={{ pathname: "/token/" + token + "/done", state: "미신청" }}
          id="third-btn"
          className="btn"
          alt="답례품 없이 끝내기 버튼"
        >
          답례품 없이 끝내기
        </Link>
      </div>
      {/* <div className="link-buttons">
        <Link
          to={`/token/${token}/survey/${prevSurveyType}/${prevSurveyNumber}/${prevTopicNumber}/${prevScreenNumber}`}
          className="link-btn"
          alt="뒤로 버튼"
        >
          뒤로
        </Link>
      </div> */}
    </div>
  );
};

export default Success;
